import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { getPropsFromData, InputField } from "../../FormField";

const HeaderForm = ({ formName, data }) => {
  return (
    <Fragment>
      <img src="/assets/images/hdf/RHI-logo.png" alt="raffles-health-insurance" />
      <table className="company-info alternate-border">
        <tbody>
          <tr>
            <td className="right-border">Company Name</td>
            <td>
              <i>For Official Use Only</i>
            </td>
          </tr>
          <tr>
            <td id="RO_CompanyName" className="right-border">
              <InputField {...getPropsFromData(data, "CompanyName")} />
            </td>
            <td>Reference Number</td>
          </tr>
        </tbody>
      </table>
      <h1 className="header">{formName}</h1>
      <p className="important-note">
        Important Note: Pursuant to Section 25(5) of the Insurance Act (Cap. 142), you are to
        disclose in this form, fully and faithfully, all facts which you ought to know, otherwise,
        nothing may be payable under the policy.
      </p>
    </Fragment>
  );
};

HeaderForm.propTypes = {
  formName: PropTypes.string.isRequired,
  data: PropTypes.object,
};

export default HeaderForm;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/common/HeaderForm.jsx